export const handleChangeBarcodeGeneratePage = (barcode) => ({
    type: 'CHANGE_BARCODE_GENERATE_PAGE', barcode
});

export const handleChangeTimerTimeBarcodeGeneratePage = (timerTime) => ({
    type: 'CHANGE_TIMER_TIME_BARCODE_GENERATE_PAGE', timerTime
});